export default __webpack_public_path__ + "static/media/1999.2eed67f3.png";